// extracted by mini-css-extract-plugin
export var chip = "_mh-0";
export var icon = "_mh-1";
export var remove = "_mh-2";
export var removeIcon = "_mh-3";